module.exports = __webpack_public_path__ + "img/kubulus-logo-hell.0ed0183f.svg";